import { render, staticRenderFns } from "./assetsOverviewCard.vue?vue&type=template&id=468f3839&scoped=true"
import script from "./assetsOverviewCard.vue?vue&type=script&lang=js"
export * from "./assetsOverviewCard.vue?vue&type=script&lang=js"
import style0 from "./assetsOverviewCard.vue?vue&type=style&index=0&id=468f3839&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468f3839",
  null
  
)

export default component.exports